/**
 * forces 'ol3-popup' namespace
 */
import Popup = require("./ol3-popup/ol3-popup");
export = Popup;